module.exports = __webpack_public_path__ + "static/media/Ali_Avatar_V1.21a8d655.svg";